import { render, staticRenderFns } from "./delete-payment-method-popup.vue?vue&type=template&id=3ded7574&"
import script from "./delete-payment-method-popup.vue?vue&type=script&lang=js&"
export * from "./delete-payment-method-popup.vue?vue&type=script&lang=js&"
import style0 from "./delete-payment-method-popup.vue?vue&type=style&index=0&id=3ded7574&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports